import React, { useState } from 'react';
import { Formik, FormikValues } from 'formik';
import * as Yup from 'yup';

import createMunicipality from '../../../lib/apiClient/municipalities/create';

import FormikInputField from '../../common/ui/FormikInputField/Input';
import PopupForm from '../../common/ui/PopupForm/Form';
import PopupFormHeader from '../../common/ui/PopupForm/Header';
import Button from '../../common/ui/Button/Button';
import PopupFormErrorMessage from '../../common/ui/PopupForm/ErrorMessage';

interface Props {
  onClose(): void;
}

const CreateMunicipalityForm = ({ onClose }: Props) => {
  const [error, setError] = useState<string | null>(null);

  const initialValues = { name: '' };

  const validationSchema = Yup.object({
    name: Yup.string()
      .max(255, 'Максимальная длина - 255 символов')
      .required('Обязательное поле'),
  });

  const submit = async (values: FormikValues) => {
    try {
      const { name } = values;
      await createMunicipality({ name });
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={submit}
    >
      <PopupForm close={onClose} closable>
        <PopupFormHeader>
          Добавление муниципалитета
          <PopupFormErrorMessage text={error ?? ''} visible={error !== null} />
        </PopupFormHeader>

        <FormikInputField
          name="name"
          placeholder="Название"
          onFocus={() => setError(null)}
        />

        <Button type="submit">Подтвердить</Button>
      </PopupForm>
    </Formik>
  );
};

export default CreateMunicipalityForm;
